import { Check, CircleAlert } from "lucide-react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

function Toaster(props: ToasterProps) {
  return (
    <Sonner
      position="bottom-center"
      offset={24}
      duration={3000}
      icons={{
        success: <Check aria-hidden className="size-4 stroke-2 text-fg-accent" />,
        error: <CircleAlert aria-hidden className="size-4 text-status-danger" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            "min-[601px]:left-1/2! min-[601px]:-translate-x-1/2! min-[601px]:w-max min-[601px]:max-w-[356px] flex h-11 items-center gap-2 rounded-full bg-surface-inverse px-5 text-sm font-medium text-fg-inverse shadow-popover",
        },
      }}
      {...props}
    />
  );
}

export { toast } from "sonner";
export { Toaster };
